"use client";

import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { useStaffTaxApplications } from "@/hooks/spacetime/use-staff-tax-applications";
import { useRowTransitions } from "@/hooks/spacetime/use-row-transitions";
import { startNavigationFeedback } from "@/lib/navigation-feedback";

export function TaxApplicationToasts({ userId }: { userId: string | null }) {
  const { applications, isReady } = useStaffTaxApplications();
  const router = useRouter();
  useRowTransitions({
    rows: applications,
    isReady,
    resetKey: userId,
    getId: (row) => row.id,
    getState: (row) => row.status,
    onAppear: (row) => {
      if (row.status !== "submitted") return;
      toast.info("New Tax Application", {
        id: `tax-application-${row.id}`,
        description: `${row.organizationName} submitted a tax exemption certificate.`,
        action: {
          label: "Review",
          onClick: () => {
            startNavigationFeedback("/settings/tax-applications");
            router.push("/settings/tax-applications");
          },
        },
      });
    },
  });
  return null;
}
